import { FC, ReactNode } from 'react';
import Link from '@base/lib/Link';

type ILeaf = {
    key?: string | number;
    title: ReactNode;
    url?: string;
    level?: number;
    onLinkClick?: () => void;
    children?: ILeaf[];
}

type ITiledTreeProps = {
    className?: string;
    list: ILeaf[];
    onLinkClick?: ILeaf['onLinkClick'];
};

export const Leaf: FC<ILeaf> = props => {
    const { title, url, level = 1, onLinkClick } = props;
    return (
        <div className={`sw-tree-leaf sw-tree-leaf-${level}`}>
            <Link href={url} onClick={onLinkClick}>{title}</Link>
        </div>
    )
};

export const TreeLevel: FC<ILeaf> = props => {
    const { level = 1, onLinkClick, children } = props;
    return (
        <div className={`sw-tree-lv sw-tree-lv-${level}`}>
            <Leaf {...props}/>
            {!!children?.length && children.map((item, index) => (
                <TreeLevel
                    key={item.key || index}
                    level={level + 1}
                    onLinkClick={onLinkClick}
                    {...item}
                />
            ))}
        </div>
    )
};


export const TiledTree: FC<ITiledTreeProps> = props => {
    const { className, list, onLinkClick } = props;
    return list.length === 0 ? null : (
        <div className={className}>
            {list.map((item, index) => (
                <TreeLevel
                    key={item.key || index}
                    onLinkClick={onLinkClick}
                    {...item}
                />
            ))}
        </div>
    )
};
